module.exports = __webpack_public_path__ + "static/media/dots-pink-icon.8569c374.svg";